import { nanoid } from '@reduxjs/toolkit';
import path from 'path';

/** Electron specific modules that will fail for static html site */

const checkCloudSite = () => {
  const pattern = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
  const url = new URL(window.location.href);
  const parts = url.pathname.split("/");

  return (parts.length >= 3)
    && (parts[1] === "viewer")
    && pattern.test(parts[2]);
};

export const electron = window.require
  ? window.require("electron")
  : null;

export const child = electron
  ? window.require("child_process")
  : null;

export const process = electron
  ? window.require("process")
  : null;

export const remote = electron?.remote;
export const shell = electron?.shell;
export const ipcRenderer = electron?.ipcRenderer;
export const dialog = remote?.dialog;
export const app = remote?.app;
export const getCurrentWindow = remote?.getCurrentWindow;
export const Menu = remote?.Menu;
export const fs = remote?.require('fs');
export const fse = remote?.require('fs-extra');
export const csv = remote?.require('fast-csv');
export const glob = remote?.require('glob');
export const isStaticSite = !electron;
export const isCloudSite = checkCloudSite();

export const storage = electron
  ? remote.require('electron-json-storage-sync')
  : null;

export const isDevMode = remote
  ? (app.isPackaged === false)
  : false;

export const tempDirectoryPath = app
  ? path.join(app.getPath('userData'), "temp")
  : null;

export const logDirectoryPath = app
  ? path.join(app.getPath('userData'), "logs")
  : null;

export const storageDirectoryPath = app
  ? path.join(app.getPath('userData'), "storage")
  : null;

export const getTemporaryFile = (suffix) => {
  return path.join(tempDirectoryPath, `${nanoid()}.${suffix}`);
};

const clearTemporaryFiles = async () => {
  if (isStaticSite) return;

  let numRemoved = 0;
  const maxTimeElapsedSeconds = 3600; // One hour
  const filenames = await fse.readdir(tempDirectoryPath);

  for (let filename of filenames) {
    const filePath = path.join(tempDirectoryPath, filename);
    const stats = await fse.stat(filePath);
    const currentDate = Date.now();
    const timeElapsed = (currentDate - stats.birthtimeMs)/1000;

    if (timeElapsed > maxTimeElapsedSeconds) {
      fse.remove(filePath);
      numRemoved += 1;
    }
  }

  if (numRemoved === 0) return;
  console.log(`Deleted ${numRemoved} temporary files`);
};

const createInitialFolders = () => {
  if (isStaticSite) return;

  if (!fs.existsSync(tempDirectoryPath)) {
    console.log("Creating temporary file folder...");
    fs.mkdirSync(tempDirectoryPath);
  }

  if (!fs.existsSync(logDirectoryPath)) {
    console.log("Creating log output folder...");
    fs.mkdirSync(logDirectoryPath);
  }
};

createInitialFolders();
clearTemporaryFiles();
